module.exports = __webpack_public_path__ + "static/media/advisors-open.57865a56.svg";